import React from 'react';
import { components } from 'react-select';

const AutocompleteMenu = (props) => {
    const { children, ...elementProps } = props;

    return (
        <components.Menu {...elementProps}>{children}</components.Menu>
    );
};

export default AutocompleteMenu;
